module.exports = __webpack_public_path__ + "89642e0208d51391680aa706bcffbfd7.png";